module.exports = __webpack_public_path__ + "static/media/daicon.258d34d4.png";